<template>
	<div class="mediaPhotos">
		<div class="photoNav">
			<!-- <dropdown :config="dropdownOptions" @setSelectedOption="tabSelected($event)"></dropdown> -->
			<select name="dropdown" 
					class="dropdown"
					@change="tabSelected($event)" 
					v-model="dropdownOptions.placeholder">
				<option class="option"
						v-for="(option, idx) in dropdownOptions.options"
						:value="option.value">{{ option.value }}</option>
			</select>			
		</div>

		<div class="photoDisplay">
			<!-- Tablet and higher resolution -->
			<div class="currDisplay">
				<div class="gallery-panel"
						v-for="(pic, idx) in img_arr"
						:key="idx">
					<img v-img:gallery :src="pic.link">
				</div>
<!-- 				<agile :key="renderKey1" class="main" ref="main" :options="carouselOptions1" :as-nav-for="nav1">
					<div class="slide" v-for="(pic, idx) in img_arr" :key="idx" :class="`slide--${idx}`">
						<img v-img :src="pic.link"/>

						<div class="overlay">
							<i class="fa fa-arrows-alt fa-2x exes"></i>
						</div>							

						<div class="caption" v-if="pic.caption">
							{{ pic.caption }}
						</div>
					</div>
				</agile>

				<agile :key="renderKey2" class="thumbnails" ref="thumbnails" :options="carouselOptions2" :as-nav-for="nav2">
					<div class="slide slide--thumbniail" v-for="(pic, idx) in img_arr" :key="idx" :class="`slide--${idx}`" @click="$refs.main.goTo(idx)">
						<img :src="pic.link"/>
					</div>
					
					<template slot="prevButton"><i class="fas fa-chevron-left"></i></template>

					<template slot="nextButton"><i class="fas fa-chevron-right"></i></template>
				</agile>

				<div class="scrollNotice">
					<i class="fa fa-arrow-left"></i>
					Swipe for more
					<i class="fa fa-arrow-right"></i>
				</div> -->
			</div>

			<!-- Mobile gallery component -->
			<div class="mobileDisplay">
				<div class="mobile_production">
					<h1 class="mobile_tab">Production</h1>
					<lightbox css="lightbox" :items="images.production.isolated" :cells="cells" ></lightbox>
				</div>

				<div class="mobile_lifestyle">
					<h1 class="mobile_tab">Lifestyle</h1>
					<lightbox css="lightbox" :items="images.lifestyle.isolated" :cells="cells"></lightbox>
				</div>

				<div class="mobile_headshots">
					<h1 class="slideUp mobile_tab">Headshots</h1>
					<lightbox css="lightbox" :items="images.headshot.isolated" :cells="cells"></lightbox>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import { VueAgile } from 'vue-agile';

import { filter, includes, map } from 'lodash';

import VueDropdown from 'vue-dynamic-dropdown'

export default{
	name: "Photos",
	data(){
		let prodName = 'Production Photos';
		let lifeName = 'Lifestyle Photos';
		let headName = 'Headshots';

		return{
			prodName : prodName,
			lifeName : lifeName,
			headName : headName,
			renderKey1: 1,
			renderKey2: 2,
			cells: 3,
			nav1: [],
			nav2: [],
			dropdownOptions:{
				options : [
					{ value: prodName },
					{ value: lifeName },
					{ value: headName },
				],
				// textColor: 'black',
				// border: '3px solid black',
				// backgroundColor: '#8F7EAB',
				placeholder: prodName,
				// width: '100px',
				// fontFamily: 'Raleway, sans-serif',
				// textAlign: 'center'
			},
			// carouselOptions1 : {
			// 	dots: false,
			// 	fade: true,
			// 	navButtons: false
			// },
			// carouselOptions2 : {
			// 	autoplay: false,
			// 	centerMode: true,
			// 	dots: false,
			// 	navButtons: false,
			// 	slidesToShow: 3,
			// 	responsive: [
			// 		{
			// 			breakpoint: 600,
			// 			settings: {
			// 				slidesToShow: 5
			// 			}
			// 		},
			// 		{
			// 			breakpoint: 1000,
			// 			settings: {
			// 				navButtons: true
			// 			}
			// 		}				
			// 	]
			// },
			mobileOptions: {
				options: {
					isEqualSize: true,
					isConstantSize: true,
					transitionDuration: 0.2
				},
				layout: {
					minSize: 50,
					maxSize: 70,
					column: [0,3],
					margin: 10
				}
			},
			images:{
				production: {
					tag: 14
				},
				lifestyle: {
					tag: 16
				},
				headshot: {
					tag: 8				}
			},
			img_arr : [{link:'', caption: null}],
			mob_img_arr : [],
			currPost: null,
			postsFiltered: []
		}
	},
	components: {
		agile: VueAgile,
		dropdown: VueDropdown
	},
	created(){
		this.syncPostsWithMedia();
		this.tabSelected(this.dropdownOptions.placeholder);
	},
	methods:{
		tabSelected : function(tab){
			switch(this.dropdownOptions.placeholder){
				case this.prodName:
					// this.tab = 'production';
					this.img_arr = this.images.production.links;
					this.mob_img_arr = this.images.production.isolated;
					this.currPost = this.images.production.post;
					break;
				case this.lifeName:
					// this.tab = 'lifestyle';
					this.img_arr = this.images.lifestyle.links;
					this.mob_img_arr = this.images.lifestyle.isolated;
					this.currPost = this.images.lifestyle.post;
					break;
				case this.headName:
					// this.tab = 'headshots';
					this.img_arr = this.images.headshot.links;
					this.mob_img_arr = this.images.headshot.isolated;
					this.currPost = this.images.headshot.post;
					break;
				default:
					// this.tab = 'production';
					this.img_arr = this.images.production.links;
					this.mob_img_arr = this.images.production.isolated;
					this.currPost = this.images.production.post;
					break;
			}
			this.renderKey1 = -this.renderKey1;
			this.renderKey2 = -this.renderKey2;
		},
		cleanText : function(input){
			let tmp = input.split('>');
			return input;
		},
		syncPostsWithMedia: function(){
			let par = this;

			// Get all media posts
        	this.postsFiltered = filter(this.posts, o => {
        		return includes(o['tags'], 13);
        	});

        	// === Get production photos
        	this.images.production.post = filter(this.posts, o => {
        		return includes(o['tags'], this.images.production.tag);
        	})[0];
        	this.images.production.links = this.extractElements(this.images.production.post);
        	this.images.production.isolated = map(this.images.production.links, m => {return m.link});

			// === Get lifestyle photos
        	this.images.lifestyle.post = filter(this.posts, o => {
        		return includes(o['tags'], this.images.lifestyle.tag);
        	})[0];
        	this.images.lifestyle.links = this.extractElements(this.images.lifestyle.post);
        	this.images.lifestyle.isolated = map(this.images.lifestyle.links, m => {return m.link});

			// === Get headshot
        	this.images.headshot.post = filter(this.posts, o => {
        		return includes(o['tags'], this.images.headshot.tag);
        	})[0];
        	this.images.headshot.links = this.extractElements(this.images.headshot.post);
        	this.images.headshot.isolated = map(this.images.headshot.links, m => {return m.link});

        	this.tabSelected(this.dropdownOptions.options[0]);
		},
		extractElements: function(post){
			let content = '<html><body>' + post.content.rendered + '</body></html>'
			let parser = new DOMParser();
			let parsedHtml = parser.parseFromString(content, 'text/html');
			let elements = parsedHtml.getElementsByTagName("figure");

			let result = [];
			// Remove first figure since its parent
			if(elements.length>0){
				for(let idx=1 ; idx<elements.length ; idx++){
					let tmp = elements[idx];
					//extract links for images
					let link = tmp.getElementsByTagName('a')[0].href;
					// Extract captions
					let caption = null;
					if(tmp.getElementsByTagName('figcaption').length>0){
						caption = tmp.getElementsByTagName('figcaption')[0].innerHTML;
					}

					result.push({
						link: link,
						caption: caption
					});
				}
			}
			return result;
		}
	},
	mounted() {
		this.nav1.push(this.$refs.thumbnails);
		this.nav2.push(this.$refs.main);
	},
	props: [ 'posts' ],
	watch: {
		posts: function(){
			this.syncPostsWithMedia();
		}
	}
}
</script>

<style lang="scss">
	@import "~@/assets/scss/_variables.scss";
	@import "~@/assets/scss/_override.scss";


	.agile{
		&__nav-button{			
			background: transparent;
			border: none;
			color: $nearWhite;
			cursor: pointer;
			font-size: 24px;
			transition-duration: .3s;
		
			.thumbnails & {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);

				&--prev{
					left: -30px;
				}
		
				&--next{
					right: -30px;
				}
			}

			&:hover{
				color: #888;
			}
		}

		&__dot{
			margin: 0 10px;

			button {
				background-color: #eee;
				border: none;
				border-radius: 50%;
				cursor: pointer;
				display: block;
				height: 10px;
				font-size: 0;
				line-height: 0;
				margin: 0;
				padding: 0;
				transition-duration: .3s;
				width: 10px;
			}

			&--current,
			&:hover{
				button{
					background-color: #888;
				}
			}
		}
	}

	// Slides styles	
	.slide{
		align-items: center;
		box-sizing: border-box;
		color: #fff;
		display: flex;
		max-height: 450px;
		justify-content: center;

		margin-bottom: 5px;

		&--thumbniail{
			cursor: pointer;
			height: 100px;
			padding: 0 5px;
			transition: opacity .3s;

			&:hover{
				opacity: .75;
			}
		}

		img{
			height: 100%;
			object-fit: cover;
			object-position: center;
			width: 100%;

			&:hover{
				& + .overlay{
					opacity: 1;
				}
			}
		}

		.caption{
			position: absolute;
			background: #545454A7;
			font-family: 'Montserrat', sans-serif;
			font-weight: 600;
			font-size: 17px;
			width: 100%;
			text-align: center;
			bottom: 0%;
			padding: 10px;			
		}

		.overlay {
			position: absolute;
			top: 10px;
			left: 10px;
			height: 40px;
			width: 40px;
			background: grey;
			border-radius: 5px;
			opacity: 0;

			.exes{
				color: white;
				position: absolute;
				left: 15%;
				top:10%;
			}
		}
	}

	@media screen and (max-width: $regularLaptopWidth){
		.slide{
			&--thumbniail{
				height:100px;
			}
		}
	}

	.lightbox{
		height: 10rem !important;
		font-family: 'Montserrat', sans-serif;
	}

	.lb-modal-close{
		color: black !important;
	}

	@media screen and (max-width: $largeMobile){
		.agile{
			display: none;
		}
	}

</style>

<style scoped lang="scss">
	@import "~@/assets/scss/_variables.scss";

	.mediaPhotos{
		max-width: 100%;
		height: 100%;
		display: grid;
		grid-template-rows: 10% 90%;

		.photoDisplay{
			height: 100%;
			width: 100%;
			overflow: hidden;
			padding: 0 1.5em;

			.currDisplay{
				// margin-bottom: 30px;
				// height: 100%;
				// width: 90%;
				// margin: auto;

				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
				grid-gap: 1rem;
				max-width: 80rem;
				margin: auto;
				padding: 1rem 0;

				img{
					width: 90%;
					height: 90%;
					object-fit: cover;
					border-radius: 0.75rem;
				}

				.thumbnails {
					margin: 0 -5px;
					width: calc(100% + 10px);
				}
			}

			.mobileDisplay{
				display: none;
			}
		}

		.photoNav{
			margin: auto;
			z-index: 10;
			// position: absolute;
			width: 90%;

			.dropdown{
				border: 5px solid $nearWhite;
				text-decoration: none;
				list-style: none;
				font-weight: bold;
				font-size: x-large;
				color: white;
				background: transparent;
				padding: 5px 30px;
				font-family: 'Montserrat', sans-serif;

				// Puting this here because of windows+chrome issue for dropdowns
				.option{
					color: initial;
				}
			}
		}		
	}


	@media screen and (max-width: $largeLaptopWidth){
		.scrollNotice{
			display: none;
		}
	}

	@media screen and (max-width: $regularLaptopWidth){
		.photoNav{
			transform: translateY(50%);
		}
	}

	@media screen and (max-width: $tabletWidth){
		.scrollNotice{
			display: block;
			width: 100%;
			color: white;
			font-family: 'Montserrat', sans-serif;
			text-align: center;			
		}
	}

	@media screen and (max-width: $largeMobile){
		.mediaPhotos{
			grid-template-rows: none;

			.photoDisplay{
				.currDisplay{
					display: none;
				}

				.mobileDisplay{
					height: 100%;
					display: grid;
					grid-template-rows: repeat(3, 33%);
    				grid-gap: 10px;

					.mobile{
						&_tab{
							font-family: 'Montserrat', sans-serif;
							font-weight: bold;
							color: $nearWhite;						
						}
					}					
				}
			}

			.photoNav{
				display: none;
			}
		}
	}

</style>